module.exports = __webpack_public_path__ + "img/218.926d1b8d.png";